module.exports = __webpack_public_path__ + "img/banner-marketingexecutive.480cca62.jpeg";